<template>
  <el-row type="flex" justify="start" align="middle" class="tg-date-search">
    <template v-if="showDateRangePicker">
      <tg-date-range-selector
        ref="selector"
        v-bind="datePickerOptions"
        :isAccountDate="isAccountDate"
        @on-change="handleRadioDate"
      ></tg-date-range-selector>
    </template>
    <el-row type="flex" justify="start">
      <tg-date-picker
        v-model="dateRange.startDate"
        :options="datePickerOptions"
      ></tg-date-picker>
      <span>-</span>
      <tg-date-picker
        v-model="dateRange.endDate"
        :options="datePickerOptions"
      ></tg-date-picker>
    </el-row>
  </el-row>
</template>

<script>
import TgDateRangeSelector from "@/components/datePicker/TgDateRangeSelector";
import TgDatePicker from "@/components/datePicker/TgDatePicker";
import date from "@/utils/date";

import { makeDateRangeProps, showDates } from "./mixins";

export default {
  components: {
    TgDatePicker,
    TgDateRangeSelector,
  },
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: "",
      },
    };
  },
  props: {
    ...makeDateRangeProps(),
    value: [Object, String],
    showDateRangePicker: Boolean,
    twoMonthLimit: Boolean,
    oneYearLimit: Boolean,
    isAccountDate: Boolean,
    mini: Boolean,
  },
  created() {
    if (this.value) {
      this.dateRange = this.value;
    }
  },
  mounted() {
    this.$emit("input", this.dateRange);

    this.select("today");
  },
  computed: {
    datePickerOptions() {
      let options = showDates.reduce((prev, ctr) => {
        prev[ctr] = this.$props[ctr];
        return prev;
      }, {});

      if (this.twoMonthLimit) {
        options.minDate = date.diffMonth(-2);
        options.maxDate = date.tomorrow();
      } else if (this.oneYearLimit) {
        options.minDate = date.diffYear(-1);
        options.maxDate = date.tomorrow();
      }

      return options;
    },
  },
  methods: {
    handleRadioDate(dateRange) {
      this.dateRange = JSON.parse(JSON.stringify(dateRange));
    },
    select(name) {
      if (this.showDateRangePicker) {
        this.$refs.selector.select(name);
      }
    },
  },
  watch: {
    dateRange(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.dateRange = val;
    },
  },
};
</script>
